<div class="tabbable__panel panel-margin right section info clearfix">
  <div class="col-sm-12 padding-left-right--2x">
    <h2>Material</h2>
  </div>
</div>

@if(!notAllowedToEditCreativesReason) {
  <div class="tabbable__body clearfix">
    @if(!adminOrPlanner) {
      <p>
        Allt material (film, URL och/eller tredjeparts-tracking) ska vara inlagd på kampanjen senast <b>{{numberOfDaysToEditForAgency}} arbetsdagar</b> innan första utsändningstillfälle. Har material inte inkommit i tid garanteras ej reklamutsändning och TV4 äger rätten att räkna ner antal CV/impressions motsvarande utebliven reklamtid samt rätten att debitera en förseningsavgift. Saknas information om URL/landningssida länkar vi till startsidan på annonsörens hemsida tillsvidare. Vid eventuella problem att addera materialet på kampanjen maila till reklamplanerare.digitalt&#64;tv4.se
      </p>
    } @else {
      <p>
        Kampanjens material går att redigera fram till kampanjslut.
      </p>
    }
    @if(!editCreatives) {
      <edit-button
        class="margin-top--2x"
        (click)="startEditCreatives()"
        textOverride="Redigera allt material"
      ></edit-button>
    } @else {
      <div class="margin-top--2x">
        <button class="button" (click)="saveEditCreatives()" [disabled]="!canSave">{{saveButtonText}}</button>
        <button class="button secondary" (click)="cancelEditCreatives()">Avbryt</button>
      </div>
    }
  </div>
}

@if(convertEditCreativesCriterium(notAllowedToEditCreativesReason)) {
  <div class="tabbable__body clearfix">
    <p>
      {{convertEditCreativesCriterium(notAllowedToEditCreativesReason)}}
    </p>
  </div>
}

@for(targeting of targetings; track $index;) {
  <div class="tabbable__body padding--2x padding-bottom--3x padding-top--3x background-color--white margin-top--3x">
    <expandable-targeting-header
      [targeting]="targeting"
      [expanded]="getTargetingExpandedFromStore(targeting.id)"
      (expandedChange)="onExpandedChange($event, targeting.id)"
    >
      @for(creative of targeting.creatives; track $index; let last = $last) {          
          <creative-details [creativeId]="creative.id" [targetingId]="targeting.id"></creative-details>
          @if(!last) {
            <div class="divider margin-top-bottom--4x"></div>
          }
      }
    </expandable-targeting-header>
  </div>
}

@if(editCreatives && !notAllowedToEditCreativesReason) {
  <div class="margin-top--2x">
    <button class="button" (click)="saveEditCreatives()" [disabled]="!canSave">{{saveButtonText}}</button>
    <button class="button secondary" (click)="cancelEditCreatives()">Avbryt</button>
  </div>
}

